// Enemy creature types and per-race status resistance. See docs/05-combat-sim §5.13.
export const CREATURE_TYPES = [
    'humanoid',
    'beast',
    'undead',
    'demon',
    'elemental',
    'mech',
    'insect',
    'dragon',
];
const baseline = {
    bleed: 1,
    burn: 1,
    freeze: 1,
    paralyze: 1,
    petrify: 1,
    daze: 1,
    poison: 1,
    other: 1,
};
export const RACE_STATUS_RESISTANCE = {
    humanoid: { ...baseline },
    beast: { ...baseline, bleed: 1.25, paralyze: 0.5 },
    undead: { ...baseline, bleed: 0, poison: 0 },
    demon: { ...baseline, freeze: 0.7, paralyze: 0.5, petrify: 0.7, daze: 0.5 },
    elemental: {
        bleed: 0.5,
        burn: 0.5,
        freeze: 0.5,
        paralyze: 0.5,
        petrify: 0.5,
        daze: 0.5,
        poison: 0.5,
        other: 0.5,
    },
    mech: { ...baseline, bleed: 0, poison: 0 /* shock x1.5 handled in effect logic */ },
    insect: { ...baseline, burn: 1.25, paralyze: 1.5, poison: 0 },
    dragon: {
        bleed: 0.5,
        burn: 0.5,
        freeze: 0.5,
        paralyze: 0.5,
        petrify: 0.5,
        daze: 0.5,
        poison: 0.5,
        other: 0.5,
    },
};
//# sourceMappingURL=races.js.map